import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
  action?: React.ReactNode;
}
export function Card({
  children,
  className = '',
  title,
  description,
  action
}: CardProps) {
  return <div className={`bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden ${className}`} data-id="element-287">
      {(title || action) && <div className="px-6 py-4 border-b border-slate-100 flex items-center justify-between" data-id="element-288">
          <div data-id="element-289">
            {title && <h3 className="text-lg font-semibold text-slate-900" data-id="element-290">{title}</h3>}
            {description && <p className="text-sm text-slate-500 mt-1" data-id="element-291">{description}</p>}
          </div>
          {action && <div data-id="element-292">{action}</div>}
        </div>}
      <div className="p-6" data-id="element-293">{children}</div>
    </div>;
}